import { render, staticRenderFns } from "./GoodsType.vue?vue&type=template&id=f394fa9c"
import script from "./GoodsType.vue?vue&type=script&lang=js"
export * from "./GoodsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports